import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useModelLabel } from "@/lib/llmModels";

function formatElapsed(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

const GenerationBanner = ({
  mode,
  queuedCount,
  model,
  startedAt,
  onHide,
}: {
  mode: "fill" | "rewrite_narratives" | "revise";
  queuedCount: number;
  model: string;
  startedAt: number;
  onHide: () => void;
}) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const modelLabel = useModelLabel(model);
  const copy = mode === "revise"
    ? `Applying ${queuedCount} change${queuedCount === 1 ? "" : "s"} — usually under a minute`
    : mode === "rewrite_narratives"
    ? "Rewriting every narrative — usually under two minutes"
    : "Researching the weekend and building the card — usually 1–2 minutes";

  return (
    <Card className="border-primary/40 bg-primary/5">
      <CardContent className="flex items-center gap-3 p-3">
        <Loader2 className="h-5 w-5 shrink-0 animate-spin text-primary" />
        <div className="min-w-0 flex-1 space-y-0.5">
          <p className="text-sm font-medium">{copy}</p>
          <p className="text-[11px] text-muted-foreground">
            {modelLabel} · {formatElapsed(now - startedAt)}
          </p>
        </div>
        <Button size="sm" variant="ghost" onClick={onHide} className="shrink-0">
          Hide
        </Button>
      </CardContent>
    </Card>
  );
};

export default GenerationBanner;
